module.exports = __webpack_public_path__ + "img/sendcall_mod.8f4b0f9c.svg";